module.exports = __webpack_public_path__ + "img/Flag_of_Tuvalu.04a62cde.svg";